import { Copy } from 'lucide-react';

import { Button } from '@/components/ui/button';

import { describeJudgment } from '../issue-judgment';

import type { OnlineEvalIssue } from '../online-eval.types';

type IssueMetadataPanelProps = {
  issue: OnlineEvalIssue;
};

const MetadataValue = ({ label, value }: { label: string; value: string }) => (
  <div className="min-w-0">
    <dt className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
      {label}
    </dt>
    <dd className="mt-1 flex items-center gap-1 font-mono text-xs">
      <span className="truncate">{value}</span>
      <Button
        variant="ghost"
        size="icon"
        className="h-7 w-7 shrink-0"
        onClick={() => void navigator.clipboard.writeText(value)}
        aria-label={`Copy ${label}`}
      >
        <Copy className="h-3.5 w-3.5" />
      </Button>
    </dd>
  </div>
);

export const IssueMetadataPanel = ({ issue }: IssueMetadataPanelProps) => (
  <div className="border-t bg-muted/30 p-4">
    <dl className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <MetadataValue label="User email" value={issue.user_email} />
      <MetadataValue label="Chat ID" value={issue.chat_id} />
      <MetadataValue label="Agent" value={issue.agent} />
      <MetadataValue label="Model" value={issue.model} />
    </dl>
    <div className="mt-4 grid gap-4 lg:grid-cols-2">
      <div>
        <h4 className="text-sm font-medium">Category description</h4>
        <p className="mt-1 text-sm text-muted-foreground">
          {issue.category_description}
        </p>
      </div>
      <div>
        <h4 className="text-sm font-medium">Evaluator judgment</h4>
        <p className="mt-1 text-sm text-muted-foreground">
          {describeJudgment(issue.judgment)}
        </p>
      </div>
    </div>
  </div>
);
